import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  viewProfile
} from './retailerAPI';


export const viewProfileAsync = createAsyncThunk(
  'retailer/viewProfile',
  async (username) => {
    const response = await viewProfile(username);
    return response;
  }
);

const initialState = {
  profile: null,
  orders: [],
  cartItems: [],
  loading: false,
  error: null,
  userProfile: null,
  profileLoading: false,
  profileError: null
};

const retailerSlice = createSlice({
  name: 'retailer',
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = null;
      state.userProfile = null;
      state.profileError = null;
    },
    clearOrders: (state) => {
      state.orders = [];
    },
    clearCart: (state) => {
      state.cartItems = [];
    }
  },
  extraReducers: (builder) => {
    builder
      // View Profile
      .addCase(viewProfileAsync.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
      })
      .addCase(viewProfileAsync.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.userProfile = action.payload;
      })
      .addCase(viewProfileAsync.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.error.message;
      });
  }
});

export const { 
  clearProfile,
  clearOrders,
  clearCart
} = retailerSlice.actions;

export default retailerSlice.reducer;

// Selectors
export const selectUserProfile = (state) => state.retailer.userProfile;
export const selectProfileLoading = (state) => state.retailer.profileLoading;
export const selectProfileError = (state) => state.retailer.profileError;